import { InjectionToken } from '@angular/core';

export interface AppConfig {
  apiUrl: string;
  production: boolean;
  apiVersion?: string;
  timeout?: number;
  authClientId: string;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
